import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { ProposalService } from 'src/app/Services/ProposalService/ProposalService.service';
import { PortfolioProductViewModel } from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { ArtistProductSummary } from 'src/app/Services/artistproducts.service';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { AcceptProposalProduct, ConsignmentProposalProduct, ConsignmentProposalRequest, ConsignmentService } from 'src/app/Services/consignment.service';
import { MessagingService } from 'src/app/Services/messaging.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'proposal-selection',
    templateUrl: './proposal-selection.component.html',
    styleUrls: ['./proposal-selection.component.css'],
    standalone: false
})
export class ProposalSelectionComponent implements OnInit {
    public consignmentProposalProducts: ConsignmentProposalProduct[] = [];
    public consignmentProducts!: ConsignmentProposalProduct;
    public consignmentProposalId: string | null = null;
    public isSelectedProposalAccepted = false;
    public showAddCommentsDialog: boolean = false;
    public authConfig: AuthConfig = {};
    public galleryComment: string | null = null;
    public AcceptProposalProductData: AcceptProposalProduct = {} as AcceptProposalProduct;
    public showRejectProposalDialog: boolean = false;
    public isProposalAccepted: boolean = false;
    public displayEmojiDialog: boolean = false;
    public activeCommentField: 'reject' | 'accept' = 'reject'; // Default to 'reject'
    public selectedProductId: string[] = [];
    public consignmentProposalData: ConsignmentProposalRequest = {} as ConsignmentProposalRequest;
    public ConsignmentProposalProduct: ConsignmentProposalProduct[] = [];
    public isProductSelected: boolean = false;
    public items: MenuItem[] | undefined;
    public home: MenuItem | undefined;
    public isAuthenticated: boolean = false;
    public ArtistName!: string;
    public ProposalSentDate!: Date;
    public ArtistProfile!: string;
    public availableProducts: ConsignmentProposalProduct[] = [];
    public acceptedProducts: ConsignmentProposalProduct[] = [];
    constructor(
        private ngxSpinnerService: NgxSpinnerService,
        private consignmentService: ConsignmentService,
        private ProposalService: ProposalService,
        private route: ActivatedRoute,
        private authService: AuthService,
        private router: Router,
        private messagingService: MessagingService,
        private confirmationService: ConfirmationService,
        private notificationsService: NotificationsService,
        private transloco: TranslocoService,
    ) { }

    ngOnInit(): void {
        this.isAuthenticated = this.authService.isAuthenticated();
        this.authConfig = this.authService.getAuthConfig();
        this.route.params.subscribe(params => {
            this.consignmentProposalId = params['id'];
            if (this.consignmentProposalId) {
                if (this.isAuthenticated) {
                    this.getConsignmentProducts(this.consignmentProposalId);
                }
                console.log('consignmentProposalId)', this.consignmentProposalId)

            }
        });
    }

    // Fetch consignment proposal products
    public getConsignmentProducts(consignmentProposalId: string) {
        this.consignmentProposalProducts = [];
        this.ngxSpinnerService.show();
        this.ProposalService.getConsignmentProposalProducts(consignmentProposalId).subscribe(

            (consignmentProposalProducts) => {
                this.ConsignmentProposalProduct = consignmentProposalProducts;
                this.items = [
                    {
                        label: this.transloco.translate('proposalSelection.proposal'), routerLink: ['/view-proposals']
                    },
                    {
                        label: this.transloco.translate('proposalSelection.selectProductsToAccept'),
                    },
                ];
                this.home = { icon: 'pi pi-home', routerLink: '/' };
                // Initialize availableProducts with all products
                this.availableProducts = [...consignmentProposalProducts];
                this.acceptedProducts = [];
                console.log("ConsignmentProposalProduct", this.ConsignmentProposalProduct); // Check console to verify data
                this.ngxSpinnerService.hide();
            },
            (error) => {
                console.error(error);
                this.ngxSpinnerService.hide();
            }
        );
        this.markasreadNotificaion()

    }

    markasreadNotificaion(): void {
        this.messagingService.markasreadNotificaion(this.consignmentProposalId!).subscribe(
            (data) => {
                console.log(data)
            },
            (error) => {
                console.error('Error fetching notifications:', error);
            }
        );
    }

    // Select product from available and move to accepted
    public selectProduct(product: ConsignmentProposalProduct) {
        const index = this.availableProducts.findIndex(p => p.ArtistProductId === product.ArtistProductId);
        if (index !== -1) {
            this.acceptedProducts.push(product);
            this.availableProducts.splice(index, 1);
        }
    }

    // Remove product from accepted and move back to available
    public removeAcceptedProduct(product: ConsignmentProposalProduct) {
        const index = this.acceptedProducts.findIndex(p => p.ArtistProductId === product.ArtistProductId);
        if (index !== -1) {
            this.availableProducts.push(product);
            this.acceptedProducts.splice(index, 1);
        }
    }
    // Show dialog to add comments while accepting or rejecting a proposal
    public showCommentsDialog(isAccepted: boolean) {
        //this.selectedConsignmentProposal = selectedProposal;
        this.isSelectedProposalAccepted = isAccepted;
        this.showAddCommentsDialog = true;
    }

    // Show reject proposal dialog
    public showRejectDialog(isAccepted: boolean) {
        //this.selectedConsignmentProposal = rowData;
        this.isSelectedProposalAccepted = isAccepted;
        this.showRejectProposalDialog = true;
    }

    // Navigate to product details page
    public goToProductDetails(product: ConsignmentProposalProduct) {
        this.router.navigate(['/', product.ArtistProduct_ArtistId, 'artworks', product.ArtistProductId]);
    }

    // Handle acceptance or rejection confirmation
    public continueAcceptanceOrRejection($event: any) {
        if (this.isSelectedProposalAccepted) {
            this.confirmationService.confirm({
                message: this.transloco.translate('proposalSelection.acceptProposalConfirm'),
                accept: () => {
                    // Gallery accepted this proposal
                    this.acceptConsignmentProposal();
                }
            });
        }
    }

    public onSelectProduct(product: ConsignmentProposalProduct) {
        // Initialize AcceptProposalProductData if it's not already initialized
        if (!this.AcceptProposalProductData) {
            this.AcceptProposalProductData = {} as AcceptProposalProduct;
        }
        // Toggle product selection
        const index = this.selectedProductId.indexOf(product.ArtistProductId);
        if (index === -1) {
            // Product not selected, add it
            this.selectedProductId.push(product.ArtistProductId);
        } else {
            // Product already selected, remove it
            this.selectedProductId.splice(index, 1);
        }
        // Update acceptedproductIds in AcceptProposalProductData
        this.AcceptProposalProductData.acceptedproductIds = this.selectedProductId.map(id => id.toString());
        // Update isProductSelected based on whether selectedProductId is not empty
        this.isProductSelected = this.selectedProductId.length > 0;
    }

    // Method to check if "Accept" button should be disabled
    public isAcceptButtonDisabled() {
        return this.acceptedProducts.length === 0;
    }

    // Accept the consignment proposal
    public acceptConsignmentProposal() {
        // Set acceptedproductIds from acceptedProducts
        this.AcceptProposalProductData.acceptedproductIds = this.acceptedProducts.map(p => p.ArtistProductId);
        console.log(this.AcceptProposalProductData)
        this.ngxSpinnerService.show();
        this.ProposalService.acceptConsignmentProposal(
            this.consignmentProposalId!,
            this.galleryComment,
            this.AcceptProposalProductData
        ).subscribe(
            (response: ResponseObject) => {
                this.ngxSpinnerService.hide();
                if (response.Success) {
                    this.isProposalAccepted = true;
                    this.showAddCommentsDialog = false;
                    this.galleryComment = '';
                    this.notificationsService.showNotification(this.transloco.translate('proposalSelection.success'), this.transloco.translate('proposalSelection.proposalAccepted'), NotificationTypes.Success);
                    this.router.navigate(['/view-proposals']);
                } else {
                    this.notificationsService.showNotification(this.transloco.translate('proposalSelection.error'), this.transloco.translate('proposalSelection.acceptProposalError', { message: response.ResponseMessage }), NotificationTypes.Error);
                }
            },
            (error) => {
                console.error(error);
                this.ngxSpinnerService.hide();
            }
        );
    }

    // Reject the consignment proposal
    public rejectProposal() {
        // Set acceptedproductIds to those NOT accepted (i.e., rejected)
        this.AcceptProposalProductData.acceptedproductIds = this.ConsignmentProposalProduct
            .filter(product => !this.acceptedProducts.some(ap => ap.ArtistProductId === product.ArtistProductId))
            .map(product => product.ArtistProductId);

        this.ngxSpinnerService.show();
        this.ProposalService.acceptConsignmentProposal(
            this.consignmentProposalId!,
            this.galleryComment,
            this.AcceptProposalProductData
        ).subscribe(
            (response: ResponseObject) => {
                this.ngxSpinnerService.hide();
                if (response.Success) {
                    this.isProposalAccepted = true;
                    this.showAddCommentsDialog = false;
                    this.galleryComment = '';
                    this.notificationsService.showNotification(this.transloco.translate('proposalSelection.success'), this.transloco.translate('proposalSelection.proposalAccepted'), NotificationTypes.Success);
                    this.router.navigate(['/view-proposals']);
                } else {
                    this.notificationsService.showNotification(this.transloco.translate('proposalSelection.error'), this.transloco.translate('proposalSelection.acceptProposalError', { message: response.ResponseMessage }), NotificationTypes.Error);
                }
            },
            (error) => {
                console.error(error);
                this.ngxSpinnerService.hide();
            }
        );
    }


    // Check if the provided date is today
    isToday(date: Date): boolean {
        const today = new Date();
        const providedDate = new Date(date);
        return providedDate.getFullYear() === today.getFullYear() &&
            providedDate.getMonth() === today.getMonth() &&
            providedDate.getDate() === today.getDate();
    }

    // Calculate the number of days since the provided date
    dispatchedDaysAgo(date: Date): number {
        const currentDate = new Date();
        const dispatchedDate = new Date(date);
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        return Math.round(Math.abs((currentDate.getTime() - dispatchedDate.getTime()) / oneDay));
    }

    // Close the add comments dialog
    public closeAddCommentsDialog($event: any) {
        this.showAddCommentsDialog = false;
        this.galleryComment = null;
    }

    // Open the emoji dialog for adding emojis to comments
    public openEmojiDialog(commentField: 'accept' | 'reject') {
        this.activeCommentField = commentField;
        this.displayEmojiDialog = !this.displayEmojiDialog;
    }

    // Add the selected emoji to the appropriate comment field
    public addEmoji(emoji: string) {
        console.log('Selected emoji:', emoji);
        if (this.activeCommentField === 'accept') {
            this.consignmentProposalData.ArtistComment = (this.consignmentProposalData.ArtistComment || '') + emoji;
        } else {
            this.galleryComment = (this.galleryComment || '') + emoji;
        }
        this.displayEmojiDialog = false;
    }

    // Close the emoji dialog
    public closeEmojiDialog($event: any) {
        this.displayEmojiDialog = false;
    }

    public showArtistOverlayPanel: boolean = false;
    public artistId: string = '';

   public viewArtistDetails(artistUsername: string) {
    if (artistUsername) {
        this.router.navigate(['/profile', artistUsername]);
    }
}


    public navigateToViewArtist(rowData: ConsignmentProposalProduct) {
        this.router.navigate(['/artist', rowData.ConsignmentProposal?.ArtistId]);
    }


    public selectedProduct!: ArtistProductSummary;
    public showProductDialog = false;
    public PortfolioProductViewModel!: PortfolioProductViewModel

    public productId: string | null = null;

    openProductDialog(productId: string) {
        this.productId = productId;
        this.showProductDialog = true;
    }

    closeProductDialog() {
        this.showProductDialog = false;
        this.productId = null;
    }


    public onShowArtistOverlay(artistId: string) {
        console.log('ArtistId:', artistId);
        this.artistId = artistId;
        this.showArtistOverlayPanel = true;
    }
    public onArtistOverlayClosed($event: any) {
        this.showArtistOverlayPanel = false;
    }
}

